import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OnClickOutSide from 'react-onclickoutside';
import Radium from 'radium';

import config from 'config';
import MoreVertIcon from 'assets/MoreVertIcon';
import MoreHorIcon from 'assets/MoreHorIcon';
import Translate from 'components/Translate';
import {myDarkBlue} from "../../../../../utils/General";

const styles = {
  list: {
    padding: '10px 0',
    position: 'absolute',
    zIndex: 30,
    backgroundColor: 'white',
    borderRadius: '10px',
    right: 5,
    top: 25,
    boxShadow: '2px 2px 5px 0px rgba(24,62,153,0.35)',
  },
  listItem: {
    borderRadius: '10px',
    fontSize: '14px',
    color: myDarkBlue,
    padding: '5px 15px',
    textAlign: 'left',
    cursor: 'pointer',
    ':hover': {
      color: '#FFFFFF',
      backgroundColor: myDarkBlue,
    },
  },
  triangle: {
    width: '10px',
    height: '10px',
    top: '-4px',
    right: '7px',
    zIndex: 20,
    position: 'absolute',
    transform: 'rotate(225deg)',
    boxShadow: '1px 1px 2px 0px rgba(24,62,153,0.35)',
  },
};

class MembersTableRowActions extends Component {
  state = {
    isOpen: false,
  };

  handleClick = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  close = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleClickOutside = () => {
    this.close();
  };

  render() {
    const { isOpen } = this.state;
    const {
      removeMember, reInviteMember, member,
    } = this.props;

    return (
      <div style={{
        textAlign: 'right',
        position: 'relative',
        minWidth: '175px',
      }}
      >
        <button
          className="no-style-button"
          type="button"
          onClick={this.handleClick}
        >
          {isOpen ? <MoreHorIcon size={5} /> : <MoreVertIcon size={5} />}
        </button>
        <ul
          className="no-style-list"
          style={[styles.list, { display: `${isOpen ? 'block' : 'none'}` }]}
        >
          <li style={styles.triangleShadow} />
          <li style={styles.triangle} />
          <li
              key="remove-member"
              style={[styles.listItem, { ':hover': { backgroundColor: myDarkBlue } }]}
              onClick={() => {
                removeMember();
                this.close();
              }}
          >
            <Translate text="removeUser" />
          </li>
          {member.status === config.statusMap.pending && (
          <li
            key="resend-invitation"
            style={styles.listItem}
            onClick={() => {
              reInviteMember(member);
              this.close();
            }}
          >
            <Translate text="resendInvitation" />
          </li>
          )}

        </ul>
      </div>
    );
  }
}

MembersTableRowActions.propTypes = {
  member: PropTypes.object.isRequired,
  reInviteMember: PropTypes.func.isRequired,
  removeMember: PropTypes.func.isRequired,
};

export default OnClickOutSide(Radium(MembersTableRowActions));



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/MembersTableRowActions.jsx